import angular from 'angular';

class AddInsuranceTemplateNotesModalCtrl {
  constructor($uibModalInstance, benefitId, actionType) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.benefitId = benefitId;
    this.actionType = actionType;
  }
}
export const loadModule = () =>
  angular
    .module('app')
    .controller(
      'AddInsuranceTemplateNotesModalCtrl',
      AddInsuranceTemplateNotesModalCtrl,
    );
